import React from 'react'
import { FOOTER_SECTIONS, APP_STORE_LINKS } from '../../../Constants'
import {
  FooterContainer,
  FooterContent,
  LogoSection,
  Logo,
  FooterSection,
  SectionTitle,
  LinkList,
  LinkItem,
  FooterLink,
  AppStoreSection,
  AppStoreButton,
  AppStoreBadge,
} from './styles'

export const Footer: React.FC = () => {
  const handlePrivacyAction = (
    e: React.MouseEvent<HTMLAnchorElement>,
    huAction?: string
  ) => {
    if (huAction) {
      e.preventDefault()
      const consentElement = document.querySelector(`[data-hu-action="${huAction}"]`)
      if (consentElement instanceof HTMLElement) {
        consentElement.click()
      }
    }
  }

  return (
    <FooterContainer role="contentinfo">
      <FooterContent>
        <LogoSection>
          <Logo
            src={
              'https://premierlacrosseleague.com/wp-content/uploads/2019/05/pll-logo-gray.png'
            }
            alt="Premier Lacrosse League"
          />
        </LogoSection>

        {FOOTER_SECTIONS.map((section, idx) => (
          <FooterSection key={section.title}>
            <SectionTitle>{section.title}</SectionTitle>
            <LinkList>
              {section.links.map((link) => (
                <LinkItem key={link.label}>
                  <FooterLink
                    href={link.url}
                    target={link.external ? '_blank' : undefined}
                    rel={link.external ? 'noopener noreferrer' : undefined}
                    onClick={(e) => handlePrivacyAction(e, link.huAction)}
                    aria-label={
                      link.external ? `${link.label} (opens in new tab)` : link.label
                    }
                  >
                    {link.label}
                  </FooterLink>
                </LinkItem>
              ))}
              {idx > 0 && (
                <LinkItem>
                  <FooterLink
                    href="#"
                    data-hu-action="cookies-notice-revoke"
                    aria-label="Revoke Consent"
                  >
                    Revoke Consent
                  </FooterLink>
                </LinkItem>
              )}
            </LinkList>
          </FooterSection>
        ))}

        <AppStoreSection>
          <AppStoreButton
            href={APP_STORE_LINKS.apple}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download on the App Store (opens in new tab)"
          >
            <AppStoreBadge
              src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83"
              alt="Download on the App Store"
            />
          </AppStoreButton>
          <AppStoreButton
            href={APP_STORE_LINKS.google}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Get it on Google Play (opens in new tab)"
          >
            <AppStoreBadge
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              alt="Get it on Google Play"
            />
          </AppStoreButton>
        </AppStoreSection>
      </FooterContent>
    </FooterContainer>
  )
}
